// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"584":"6a913f49","787":"ef7d7676"}[chunkId] + ".chunk.js";
};